import React, { Component } from 'react'
import moment from 'moment'
import queryString from 'query-string'

import * as dateFormatting from './date_formatting'
import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Controls from '../common/controls'

const MAX_WEEKS = 13
const DAYS_IN_WEEK = 7
const MAX_TIMES_GROUPS = 5
const MAX_TIMES_DISPLAYED = 5

class Coaching1 extends Component {
  constructor(props) {
    super(props)

    this.props.updateActivePage(1)
    this.next = this._next.bind(this)
    this.setNextWeek = this._setNextWeek.bind(this)
    this.setPreviousWeek = this._setPreviousWeek.bind(this)
    this.setNextSlotGroup = this._setNextSlotGroup.bind(this)
    this.setPreviousSlotGroup = this._setPreviousSlotGroup.bind(this)

    this.state = {
      allDates: [],
      currentWeek: 0,
      selectedWeek: [],
      daySelected: { display: false, value: null },
      inspiratorTimes: null,
      allSlotTimes: [],
      selectedSlotTimes: [],
      currentSlotTimeIndex: 0,
      slotTimeSelected: { display: false, value: null },
      ariaLivePolite: '',
      ariaLiveAssertive: ''
    }
  }

  setInitialWeeks(numWeeks, startDate) {
    const numDays = DAYS_IN_WEEK * numWeeks
    let allDates = []
    for (let i = 0; i < numDays; ++i) {
      allDates[i] = moment(startDate).add(i, 'days')
    }
    
    this.setState({ ...this.state,
      allDates: allDates,
      selectedWeek: allDates.slice(0, DAYS_IN_WEEK)
    })
  }

  async _setNextWeek() {
    if (this.state.currentWeek + 1 < MAX_WEEKS) {
      let nextWeek = this.state.currentWeek + 1
      let days = []

      let firstDate = this.state.allDates[nextWeek * DAYS_IN_WEEK]
      let data = await this.props.getInspiratorTimes(this.props.history, firstDate)
      let newInspiratorTimes = null
      
      if (data.status === 'success') {
        newInspiratorTimes = this.formatInspiratorTimes(data.data)
      }

      for (let i = 0; i < DAYS_IN_WEEK; ++i) {
        days[i] = this.state.allDates[nextWeek * DAYS_IN_WEEK + i]
      }
      this.setState({ ...this.state,
        inspiratorTimes: data.status === 'success' ? newInspiratorTimes : this.state.inspiratorTimes,
        currentWeek: nextWeek,
        selectedWeek: days,
        daySelected: {
          display: false,
          value: null
        }
      })
    }
  }
  
  async _setPreviousWeek() {
    if (this.state.currentWeek > 0) {
      let previousWeek = this.state.currentWeek - 1
      let days = []

      let firstDate = this.state.allDates[previousWeek * DAYS_IN_WEEK]
      let data = await this.props.getInspiratorTimes(this.props.history, firstDate)
      let newInspiratorTimes = null
      
      if (data.status === 'success') {
        newInspiratorTimes = this.formatInspiratorTimes(data.data)
      }

      for (let i = 0; i < DAYS_IN_WEEK; ++i) {
        days[i] = this.state.allDates[previousWeek * DAYS_IN_WEEK + i]
      }
      this.setState({ ...this.state,
        inspiratorTimes: data.status === 'success' ? newInspiratorTimes : this.state.inspiratorTimes,
        currentWeek: previousWeek,
        selectedWeek: days,
        daySelected: {
          display: false,
          value: null
        }
      })
    }
  }

  _setNextSlotGroup() {
    if ((this.state.currentSlotTimeIndex + 1) * MAX_TIMES_DISPLAYED < this.state.allSlotTimes.length && this.state.currentSlotTimeIndex + 1 < MAX_TIMES_GROUPS) {
      let nextSlotTimeIndex = this.state.currentSlotTimeIndex + 1
      let newSlotTimes = []
      for (let i = 0; i < MAX_TIMES_DISPLAYED; ++i) {
        if (!this.state.allSlotTimes[nextSlotTimeIndex * MAX_TIMES_DISPLAYED + i]) break
        newSlotTimes[i] = this.state.allSlotTimes[nextSlotTimeIndex * MAX_TIMES_DISPLAYED + i]
      }
      this.setState({ ...this.state,
        selectedSlotTimes: newSlotTimes,
        currentSlotTimeIndex: nextSlotTimeIndex,
      })
    }
  }

  _setPreviousSlotGroup() {
    if (this.state.currentSlotTimeIndex > 0) {
      let previousSlotTimeIndex = this.state.currentSlotTimeIndex - 1
      let newSlotTimes = []
      for (let i = 0; i < MAX_TIMES_DISPLAYED; ++i) {
        newSlotTimes[i] = this.state.allSlotTimes[previousSlotTimeIndex * MAX_TIMES_DISPLAYED + i]
      }
      this.setState({ ...this.state,
        selectedSlotTimes: newSlotTimes,
        currentSlotTimeIndex: previousSlotTimeIndex,
      })
    }
  }

  setDaySelected(date) {
    if (this.state.daySelected.value && dateFormatting.dateEqual(date, this.state.daySelected.value)) {
      return null
    }
    let allSlotTimes = []
    const { timeSlots } = this.state.inspiratorTimes
    for (let i = 0; i < timeSlots.length; ++i) {
      if (dateFormatting.dateEqual(date, timeSlots[i].slotDate)) {
        allSlotTimes = timeSlots[i].slotTimes.slice(0, timeSlots[i].slotTimes.length)
        break
      }
    }
      
    this.setState({ ...this.state,
      allSlotTimes: allSlotTimes,
      selectedSlotTimes: allSlotTimes.slice(0, MAX_TIMES_DISPLAYED),
      currentSlotTimeIndex: 0,
      daySelected: { 
        display: true,
        value: date 
      }
    })
  }

  setSlotTimeSelected(slotTime) {
    if (this.state.slotTimeSelected.value === slotTime) {
      return null
    }
    this.setState({ ...this.state,
      slotTimeSelected: { display: true, value: slotTime },
    })
  }

  firstWeek() {
    if (this.state.selectedWeek.length > 0 && this.state.currentWeek === 0) {
      return 'coaching-transparent'
    }
    return ''
  }

  lastWeek() {
    if (this.state.selectedWeek.length > 0 && this.state.currentWeek === (MAX_WEEKS - 1)) {
      return 'coaching-transparent'
    }
    return ''
  }

  firstSlotGroup() {
    if (this.state.selectedSlotTimes.length > 0 && this.state.currentSlotTimeIndex === 0) {
      return 'coaching-transparent'
    }
    return ''
  }
  
  lastSlotGroup() {
    if (this.state.selectedSlotTimes.length > 0 && 
      (this.state.currentSlotTimeIndex === (MAX_TIMES_GROUPS - 1) || (this.state.currentSlotTimeIndex + 1) * MAX_TIMES_DISPLAYED >= this.state.allSlotTimes.length)) {
      return 'coaching-transparent'
    }
    return ''
  }

  selectedDayCss(date) {
    if (date === this.state.daySelected.value) {
      return 'selected-day'
    }
    return ''
  } 

  selectedSlotTimeCss(date) {
    if (date === this.state.slotTimeSelected.value) {
      return 'selected-time'
    }
    return ''
  }


  dateHasSessions(date) {
    if (this.state.inspiratorTimes) {
      const { inspiratorTimes } = this.state
      for (let i = 0; i < inspiratorTimes.timeSlots.length; ++i) {
        if (dateFormatting.dateEqual(date, inspiratorTimes.timeSlots[i].slotDate)) {
          return true
        }
      }
    }
    return false
  }

  setActiveInactive(date) {
    if (this.dateHasSessions(date)) {
      return 'active-date'
    }
    return 'inactive-date'
  }

  _next() {
    if (this.state.slotTimeSelected.value) {
      return this.props.next(this.props.match.path, this.state)
    }
  }

  formatInspiratorTimes(inspiratorTimes) {  
    let newTimes = []
    let allSlotTimes = []

    const { timeSlots } = inspiratorTimes
    for (let i = 0; i < timeSlots.length; ++i) {
      for (let j = 0; j < timeSlots[i].slotTimes.length; ++j) {
        allSlotTimes.push(moment(timeSlots[i].slotTimes[j]))
      }
    }
    
    newTimes[0] = {
      slotTimes: [allSlotTimes[0]],
      slotDate: allSlotTimes[0]
    }

    let currentCounter = 0
    
    for(let i = 1; i < allSlotTimes.length; ++i) {
      if (allSlotTimes[i].month() > newTimes[currentCounter].slotDate.month() || allSlotTimes[i].date() > newTimes[currentCounter].slotDate.date()) {
        ++currentCounter
        newTimes[currentCounter] = {
          slotTimes: [allSlotTimes[i]],
          slotDate: allSlotTimes[i]
        }
      } else {
        newTimes[currentCounter].slotTimes.push(allSlotTimes[i])
      }
    }

    let newInspiratorTimes = JSON.parse(JSON.stringify(inspiratorTimes))
    newInspiratorTimes.timeSlots = newTimes

    return newInspiratorTimes
  } 

  async componentDidUpdate() {
    if (this.props.apiError) {
      let firstDate = moment(this.state.allDates[this.state.currentWeek * DAYS_IN_WEEK])
      let data = await this.props.getInspiratorTimes(this.props.history, firstDate)
      if (data.status === 'success') {
        this.props.setApiErrorFalse()
        this.setState({ ...this.state,
          inspiratorTimes: this.formatInspiratorTimes(data.data),
          daySelected: {
            display: false,
            value: null
          },
          slotTimeSelected: {
            display: false, 
            value: null 
          },
        })
      }
    }

    if (this.state.inspiratorTimes && !this.state.ariaLivePolite && !this.state.ariaLiveAssertive) {
      setTimeout( () => {
        this.setState({
          ariaLivePolite: 'polite',
          ariaLiveAssertive: 'assertive'
        })
      }, 2000) 
    }
  }

  async componentDidMount() {
    let startDate = moment().add(1, 'days')
    let noFirstFiveWeeks = false
    let emptyWeekCounter = 0
    
    let data = await this.props.getInspiratorTimes(this.props.history, startDate)
    if (data.data && data.data.inspiratorId) {
      this.props.addInspiratorHistory(this.props.history, data.data.inspiratorId)
    }

    while (data.errorCodeNum === 1002) {
      startDate.add(1, 'days')
      data = await this.props.getInspiratorTimes(this.props.history, startDate)
      if (data.data && data.data.inspiratorId) {
        this.props.addInspiratorHistory(this.props.history, data.data.inspiratorId)
      }
    }

    while (data.errorCodeNum === 1000) {
      if (noFirstFiveWeeks === true) {
        return this.props.next(this.props.match.path, this.state)
      } else {
        noFirstFiveWeeks = true
        startDate.add(35, 'days')
        data = await this.props.getInspiratorTimes(this.props.history, startDate)
        if (data.data && data.data.inspiratorId) {
          this.props.addInspiratorHistory(this.props.history, data.data.inspiratorId)
        }
      }
    }

    while (data.errorCodeNum === 1100) {
      if (emptyWeekCounter >= 10) {
        return this.props.next(this.props.match.path, this.state)
      } else {
        emptyWeekCounter++
        startDate.add(7, 'days')
        data = await this.props.getInspiratorTimes(this.props.history, startDate)
        if (data.data && data.data.inspiratorId) {
          this.props.addInspiratorHistory(this.props.history, data.data.inspiratorId)
        }
      }
    }

    this.setInitialWeeks(MAX_WEEKS, startDate)

    this.setState({ 
      inspiratorTimes: this.formatInspiratorTimes(data.data)
    })
    
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  displayDatesShown() {
    if (this.state.selectedWeek.length > 0) {
      const { selectedWeek } = this.state
      const lastDate = selectedWeek[selectedWeek.length - 1]
      const month1 = dateFormatting.numToMonthLong(selectedWeek[0].month())
      const day1 = selectedWeek[0].date()
      const month2 = dateFormatting.numToMonthLong((lastDate.month()))
      const day2 = lastDate.date()
      const year = lastDate.year()
      const displayedDate = `${month1} ${day1} - ${month2} ${day2}, ${year}`
      return (
        <div className="coaching-subheader">
          {displayedDate} 
        </div>
      )
    }
  }

  displaySelectedSlotTime() {
    const { value } = this.state.slotTimeSelected
    if(value) {
      return (
        <div aria-atomic="true">
          <div id="selected-session" tabIndex="-1" className="coaching-subheader">
            Your selected session is {`${dateFormatting.completeDatePrettyPrint(value)} (${dateFormatting.getTimezoneLong(value)})`}
          </div>
          <Controls ariaLabel="Confirm" className="coaching-button" ariaDescribedby="selected-session" nextLabel="CONFIRM SESSION" next={this.next} />
        </div>
      )
    }
  }

  displayTimes() {
    let chooseTimes = null
    if (this.state.daySelected.display) {
      const slotTimes = this.state.selectedSlotTimes.map(slotTime => 
        <label key={slotTime.valueOf()} className={"active-time " + this.selectedSlotTimeCss(slotTime)}>
          <input className="time-selector" onClick={this.setSlotTimeSelected.bind(this, slotTime)} name="time-selector" type="radio" />
          <span className="show-time">{dateFormatting.timePrettyPrint(slotTime)}</span>
        </label>
      )
      chooseTimes =
        <div>
          <div className="coaching-subheader" id="coaching-subheader-select-time">
            <div> 
              Select a Time 
            </div>
            <div>
              Choose a time for your <strong>20 minute</strong> call ({dateFormatting.getTimezoneShort(this.state.daySelected.value)}/{dateFormatting.getTimezoneLong(this.state.daySelected.value)})
            </div>
          </div>
          <div className="time-buttons">
            <input
              className={"time-change " + this.firstSlotGroup()}
              tabIndex={this.firstSlotGroup() ? "-1" : "0"}
              aria-hidden={this.firstSlotGroup() ? "true" : "false"}
              onClick={this.firstSlotGroup() ? null : this.setPreviousSlotGroup}
              aria-label={this.firstSlotGroup() ? "" : "Previous Times button"}
              type="image"
              src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/92aa86b9-c89a-43af-baef-8dc2fbe0bd6c.png"
              alt=""
            />
            <div className="slot-times" role="radiogroup" aria-labelledby={this.state.slotTimeSelected.display ? "" : "coaching-subheader-select-time"}>
              {slotTimes ? slotTimes : <div></div>}
            </div>
            <input
              className={"time-change " + this.lastSlotGroup()}
              tabIndex={this.lastSlotGroup() ? "-1" : "0"}
              aria-hidden={this.lastSlotGroup() ? "true" : "false"}
              onClick={this.lastSlotGroup() ? null : this.setNextSlotGroup}
              aria-label={this.lastSlotGroup() ? "" : "Next Times button"}
              type="image"
              src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/bfe73c46-b4b2-45a2-a322-6003a55d7f3c.png"
              alt=""
            /> 
          </div>
        </div>
    }
    return (
      <div id="time-display" aria-live={this.state.ariaLivePolite || "off"}>
        {chooseTimes}
        {this.displaySelectedSlotTime()}
      </div>
    )
  }

  render() {
    let selectedWeek = null
    let dateButtonGroup = null
    if (this.state.inspiratorTimes) {
      selectedWeek = this.state.selectedWeek.map(day => {
        return (
          <label key={day.valueOf()} className={this.setActiveInactive(day) + " " + this.selectedDayCss(day)}>
            <input
              id={day.valueOf().toString()}
              className="date-selector"
              onClick={this.setDaySelected.bind(this, day)}
              type="radio"
              name="day"
              aria-label={`${dateFormatting.speechDateValue(day)} ${this.setActiveInactive(day) === "active-date" ? "Available" : "Unavailable"}`}
              disabled={!this.dateHasSessions(day)}
            />
            <span aria-hidden="true" className="show-week-day">{dateFormatting.numToDayOfWeekShortCap(day.day())}<br/>{day.date()}</span>
          </label>
        )}
      )
      dateButtonGroup =
      <div id="week-display" aria-live={this.state.ariaLiveAssertive || "off"}>
        <div className="coaching-subheader">
          Select a Day
        </div>
        <div aria-atomic="true">
          {this.displayDatesShown()}
        </div>
        <div className="date-buttons">
          <input
            id="previous-week-button"
            className={"week-change " + this.firstWeek()}
            tabIndex={this.firstWeek() ? "-1" : "0"}
            aria-hidden={this.firstWeek() ? "true" : "false"}
            type="image"
            onClick={this.setPreviousWeek}
            aria-label="Previous Week"
            src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/bf5a4c96-a7a7-45e2-ba76-12a78167e80e.png"
            alt=""
          />
          <div id="displayed-week" className="selected-week" role="radiogroup">
            {selectedWeek ? selectedWeek : <div></div>}
          </div>
          <input
            id="next-week-button"
            className={"week-change " + this.lastWeek()}
            tabIndex={this.lastWeek() ? "-1" : "0"}
            aria-hidden={this.lastWeek() ? "true" : "false"}
            type="image"
            onClick={this.setNextWeek}
            aria-label="Next Week"
            src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/946d0a41-ef53-435d-ba6c-485b161e9f22.png"
            alt=""
          />
        </div>
      </div>
    } else {
      dateButtonGroup = <div id="week-display" aria-live={this.state.ariaLiveAssertive || "off"}></div>
    }

    return (
      <div>
        <AriaMessage message="Navigated to book coaching session page" />
        <Title>Schedule Your Coaching Sessions</Title>
        <div className="container">
          <div className="coaching-header">
            Let's schedule you in for your first coaching session!
          </div>
          <br aria-hidden="true" />
          {dateButtonGroup}
          {this.displayTimes()}
        </div>
      </div>
    )
  }
}

export default Coaching1  